<template>
  <div class="list-detail">
    <div
      v-for="moduleKey in Object.keys(flatFormModule) || []"
      :key="moduleKey"
    >
      <h3 class="item-title">
        <span class="text">{{ moduleKey }}</span>
      </h3>
      <a-row
        :gutter="8"
        v-for="(row, rowKey) in flatFormModule[moduleKey]"
        :key="rowKey"
      >
        <a-col v-for="col in row" :key="col.field" :span="col.span || 6">
          <a-form-item v-if="col.slot" class="form-item">
            <slot :name="col.slot"></slot>
          </a-form-item>
          <a-form-item v-else class="form-item">
            <template #label>
              <div class="form-label">
                <span class="label-text"
                  >{{ col.label }}
                  <a-tooltip v-if="col.tip" placement="top">
                    <template #title>
                      <div v-html="col.tip"></div>
                    </template>
                    <icon-font class="question-icon" icon="icon-wenhao" />
                  </a-tooltip>
                </span>
                <span v-if="col.subTitle" class="label-sub-text">{{
                  col.subTitle
                }}</span>
              </div>
            </template>
            <span v-if="col.isTags && col.formatter">
              <span v-for="item in col.formatter(form[col.field])" :key="item">
                <a-tag style="margin-top: 4px" v-if="item">{{ item }}</a-tag>
                <span v-else>-</span>
              </span>
            </span>
            <span v-else-if="col.isTable && col.formatter">
              <a-table
                :data-source="col.formatter(form[col.field])"
                :columns="col.columns"
                :pagination="false"
                size="small"
                bordered
              >
                <template #bodyCell="{ text, column }">
                  <template v-if="column.isTags && text.length">
                    <a-tag v-for="item in text" :key="item">{{ item }}</a-tag>
                  </template>
                  <template v-else>{{ text || "-" }}</template>
                </template>
              </a-table>
            </span>
            <span v-else-if="col.formatter" class="info-text">{{
              col.formatter(
                form[col.field],
                formOptions[col.optionsFiled || col.field]
              )
            }}</span>
            <span v-else class="info-text">{{ form[col.field] || "-" }}</span>
          </a-form-item>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed, onMounted, PropType, reactive } from "vue";
import {
  OriginFormModule,
  FormOptions,
  OriginFormFlat,
  FormatterFn
} from "./type";
import { useOriginFormFlat } from "./config";

const props = defineProps({
  form: {
    type: Object,
    required: true
  },
  formOptions: {
    type: Object,
    required: true
  },
  originFormModule: {
    type: Object as PropType<OriginFormModule>,
    required: true
  },
  // 传入控制隐藏的字段 同时一定要配置key
  visibleState: {
    type: Object as PropType<Record<string, () => boolean>>,
    required: true
  },
  formatterFnMap: {
    type: Object as PropType<Record<string, FormatterFn>>,
    required: true
  },
  modulesVisibleState: {
    type: Object as PropType<Record<string, () => boolean>>
  }
});

const flatFormModule = reactive({} as OriginFormFlat);
const formOptions = computed(() => {
  return props.formOptions as FormOptions;
});

onMounted(() => {
  Object.assign(
    flatFormModule,
    useOriginFormFlat(
      props.originFormModule,
      props.visibleState,
      props.formatterFnMap,
      props.modulesVisibleState
    )
  );
});
</script>

<script lang="ts">
export default {
  name: "ListDetail"
};
</script>

<style lang="less" scoped>
.list-detail {
  margin-bottom: 24px;
  .item-title {
    font-size: 16px;
    font-weight: 500;
    padding: 6px;
    position: relative;
    margin-bottom: 16px;
    &::before {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      content: "";
      width: 6px;
      height: 18px;
      border-radius: 1px;
      background-color: #409eff;
    }
    .text {
      margin-left: 18px;
    }
  }

  .form-item {
    .form-label {
      display: inline-flex;
      flex-direction: column;
      line-height: 1;
      color: #7585a2;
      .label-text {
        font-weight: 500;
      }
      .label-sub-text {
        font-weight: 400;
        font-size: 12px;
        margin-top: 1px;
      }
      .required-item {
        &::before {
          display: inline-block;
          content: "*";
          color: #f00;
          margin-right: 3px;
        }
      }
    }

    .info-text {
      // font-weight: 500;
      margin-left: 4px;
      word-break: break-all;
    }
  }
  .question-icon {
    vertical-align: text-top;
    margin-left: 0;
    font-size: 12px;
  }
}
</style>
